<div class="dsh-mobile-user-bar" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="dsh-mobile-user-bar-username">{{ userName }}</div>
    <dsh-bi class="dsh-mobile-user-bar-exit" icon="arrow-right-square" (click)="logout()"></dsh-bi>
</div>
